import React, { useState, useEffect } from 'react';
import { baseURL } from '../apiConfig'; // <-- Apni nayi central file se baseURL import kiya

import './StockIn.css';

const StockIn = () => {
    // const baseURL = process.env.REACT_APP_API_URL || 'http://10.179.18.97:8000';
    // 1. Form variables initial state
    const [formData, setFormData] = useState({
        purchaseBillNo: '',
        metal: '',
        purity: '',
        tagText: '',
        itemGroup: '',
        itemName: '',
        weight: '',
        making: '',
        makingType: 'Fixed',
        remarks: ''
    });

    const [itemsList, setItemsList] = useState([]);
    const [isEditing, setIsEditing] = useState(false);
    const [isDBRecord, setIsDBRecord] = useState(false); 
    
    // Naya state Tag Print feature ke liye
    const [printFrom, setPrintFrom] = useState('');
    const [printTo, setPrintTo] = useState('');

    // 🔥 Dynamic Master Arrays for Dependent State
    const [masterMetals, setMasterMetals] = useState([]);
    const [masterPurities, setMasterPurities] = useState([]);
    const [masterGroups, setMasterGroups] = useState([]);
    const [masterNames, setMasterNames] = useState([]);

    // 1️⃣ LEVEL 1: Page Load hone par unique metals fetch karna
    // 1️⃣ LEVEL 1: Page Load hone par unique metals fetch karna (With TagID Protection)
    const loadInitialMetals = async () => {
        try {
            // const response = await fetch('http://127.0.0.1:8000/api/master/dropdowns/');
            const response = await fetch(`${baseURL}/api/master/dropdowns/`);
            
            const data = await response.json();
            if (data.success && data.metals.length > 0) {
                setMasterMetals(data.metals);
                
                // 🔥 Tag ID aur Purchase Bill ko bina chhode baaki cascade trigger karenge
                setFormData(prev => {
                    const freshForm = {
                        ...prev,
                        metal: data.metals[0]
                    };
                    // Next steps ke liye cascade trigger lagayenge safe state ke sath
                    handleCascadeChange('metal', data.metals[0], freshForm);
                    return freshForm;
                });
            }
        } catch (error) {
            console.error("Initial Metals load nahi ho paaye:", error);
        }
    };

    // 🔄 Master Cascade Chain Handler for Dynamic Dropdowns (🔥 MOBILE STUCK FIX)
    const handleCascadeChange = async (fieldName, value, currentFormState = null) => {
        // Base structure to work with latest form snapshot
        let updatedForm = currentFormState ? { ...currentFormState } : { ...formData };
        updatedForm[fieldName] = value;

        // 🔥 CRITICAL MOBILE FIX: Pehle select kiye gaye metal ko instant state me save karo 
        // taaki UI stuck na ho aur change transparently dikhe
        setFormData(prev => ({ ...prev, [fieldName]: value }));

        try {
            // if (fieldName === 'metal') {
            //     // Fetch purities based on chosen metal
            //     const res = await fetch(`${baseURL}/api/master/dropdowns/?metal=${value}`);
                                
            //     const data = await res.json();
            //     if (data.success) {
            //         setMasterPurities(data.purities);
            //         // const defaultPurity = data.purities[0] || '';
            //         // updatedForm.purity = defaultPurity;
            //         const targetPurity = (currentFormState && currentFormState.purity) ? currentFormState.purity : (data.purities[0] || '');
            //         updatedForm.purity = targetPurity;
                    
            //         // Trigger deep layer 3 chain automatically
            //         if (defaultPurity) {
            //             const nextRes = await fetch(`${baseURL}/api/master/dropdowns/?metal=${value}&purity=${defaultPurity}`);
                                                
            //             const nextData = await nextRes.json();
            //             setMasterGroups(nextData.groups);
            //             // const defaultGroup = nextData.groups[0] || '';
            //             // updatedForm.itemGroup = defaultGroup;
            //             const targetGroup = (currentFormState && currentFormState.itemGroup) ? currentFormState.itemGroup : (nextData.groups[0] || '');
            //             updatedForm.itemGroup = targetGroup;
            //             // Trigger final layer 4 chain automatically
            //             if (defaultGroup) {
            //                 const finalRes = await fetch(`${baseURL}/api/master/dropdowns/?metal=${value}&purity=${defaultPurity}&itemGroup=${defaultGroup}`);
                                                        
            //                 const finalData = await finalRes.json();
            //                 setMasterNames(finalData.itemNames);
            //                 // updatedForm.itemName = finalData.itemNames[0] || '';
            //                 const targetName = (currentFormState && currentFormState.itemName) ? currentFormState.itemName : (finalData.itemNames[0] || '');
            //                 updatedForm.itemName = targetName;
            //             } else {
            //                 setMasterNames([]);
            //                 updatedForm.itemName = '';
            //             }
            //         } else {
            //             setMasterGroups([]);
            //             setMasterNames([]);
            //             updatedForm.itemGroup = '';
            //             updatedForm.itemName = '';
            //         }
            //     }
            // }
            if (fieldName === 'metal') {
                // Fetch purities based on chosen metal
                const res = await fetch(`${baseURL}/api/master/dropdowns/?metal=${value}`);
                                
                const data = await res.json();
                if (data.success) {
                    setMasterPurities(data.purities);
                    
                    const targetPurity = (currentFormState && currentFormState.purity) ? currentFormState.purity : (data.purities[0] || '');
                    updatedForm.purity = targetPurity;
                    
                    // Trigger deep layer 3 chain automatically
                    if (targetPurity) {  // <-- Yahan theek kiya
                        const nextRes = await fetch(`${baseURL}/api/master/dropdowns/?metal=${value}&purity=${targetPurity}`); // <-- Yahan theek kiya
                                                
                        const nextData = await nextRes.json();
                        setMasterGroups(nextData.groups);
                        
                        const targetGroup = (currentFormState && currentFormState.itemGroup) ? currentFormState.itemGroup : (nextData.groups[0] || '');
                        updatedForm.itemGroup = targetGroup;
                        
                        // Trigger final layer 4 chain automatically
                        if (targetGroup) { // <-- Yahan theek kiya
                            const finalRes = await fetch(`${baseURL}/api/master/dropdowns/?metal=${value}&purity=${targetPurity}&itemGroup=${targetGroup}`); // <-- Yahan theek kiya
                                                        
                            const finalData = await finalRes.json();
                            setMasterNames(finalData.itemNames);
                            
                            const targetName = (currentFormState && currentFormState.itemName) ? currentFormState.itemName : (finalData.itemNames[0] || '');
                            updatedForm.itemName = targetName;
                        } else {
                            setMasterNames([]);
                            updatedForm.itemName = '';
                        }
                    } else {
                        setMasterGroups([]);
                        setMasterNames([]);
                        updatedForm.itemGroup = '';
                        updatedForm.itemName = '';
                    }
                }
            } 
            else if (fieldName === 'purity') {
                // Fetch groups based on metal + chosen purity
                const res = await fetch(`${baseURL}/api/master/dropdowns/?metal=${updatedForm.metal}&purity=${value}`);
                const data = await res.json();
                if (data.success) {
                    setMasterGroups(data.groups);
                    const defaultGroup = data.groups[0] || '';
                    updatedForm.itemGroup = defaultGroup;

                    if (defaultGroup) {
                        const nextRes = await fetch(`${baseURL}/api/master/dropdowns/?metal=${updatedForm.metal}&purity=${value}&itemGroup=${defaultGroup}`);
                        const nextData = await nextRes.json();
                        setMasterNames(nextData.itemNames);
                        updatedForm.itemName = nextData.itemNames[0] || '';
                    } else {
                        setMasterNames([]);
                        updatedForm.itemName = '';
                    }
                }
            } 
            else if (fieldName === 'itemGroup') {
                // Fetch item names based on metal + purity + chosen group
                const res = await fetch(`${baseURL}/api/master/dropdowns/?metal=${updatedForm.metal}&purity=${updatedForm.purity}&itemGroup=${value}`);
                const data = await res.json();
                if (data.success) {
                    setMasterNames(data.itemNames);
                    updatedForm.itemName = data.itemNames[0] || '';
                }
            }

            // Finally update full backend validated state seamlessly using functional updater
            setFormData(prev => ({
                ...prev,
                ...updatedForm
            }));

        } catch (error) {
            console.error("Cascading call failed:", error);
        }
    };

    // Page load hote hi automatic agla Tag ID aur metals lane wala block
    const fetchNextTagId = async () => {
        try {
            const response = await fetch(`${baseURL}/api/get_next_tag_id/`);
            const data = await response.json();
            if (data.success) {
                setFormData(prev => ({ ...prev, tagText: data.next_tag_id }));
            }
        } catch (error) {
            console.error("Error fetching next tag ID:", error);
        }
    };

    useEffect(() => {
        fetchNextTagId();
        loadInitialMetals();
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        // Agar dynamic dropdown change ho raha h to cascade flow chalao, nahi to regular entry
        if (name === 'metal' || name === 'purity' || name === 'itemGroup') {
            handleCascadeChange(name, value);
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    // 🔍 FIXED SEARCH LOGIC: Re-building cascading array upon searching successfully
    const handleSearch = async () => {
        if (!formData.tagText) {
            alert("Pehle Search karne ke liye Tag ID likhiye!");
            return;
        }

        const localItem = itemsList.find(item => item.tagText === formData.tagText);
        if (localItem) {
            setFormData(localItem);
            setIsEditing(true);
            setIsDBRecord(false);
            return;
        }

        try {
            const response = await fetch(`${baseURL}/api/get_stock_by_tag/?tag=${formData.tagText}`);
            const data = await response.json();
            
            if (data.status === 'sold_error') {
                alert(data.message);
                setIsEditing(false);
                setIsDBRecord(false);
                return;
            }

            // if (data.status === 'success') {
            //     const fetchedData = {
            //         purchaseBillNo: data.purchase_v_no || '',
            //         metal: data.item_type || '',       
            //         purity: data.category || '',         
            //         tagText: formData.tagText,
            //         itemGroup: data.groups || '',      
            //         itemName: data.item || '',             
            //         weight: data.weight || '',
            //         making: data.making || '',
            //         remarks: data.remarks || ''
            //     };

            if (data.status === 'success') {
            const fetchedData = {
                purchaseBillNo: data.purchaseBillNo || '', // Name theek kiya
                metal: data.metal || '',                   // Name theek kiya
                purity: data.purity || '',                 // Name theek kiya
                itemGroup: data.itemGroup || '',           // Name theek kiya
                itemName: data.itemName || '',             // Name theek kiya
                tagText: formData.tagText,                
                weight: data.weight || '',
                making: data.making || '',
                makingType: data.makingType || 'Fixed',
                remarks: data.remarks || ''
            };

                setIsEditing(true);
                setIsDBRecord(true); 
                alert("Database se Tag mil gaya! ");

                // Force cascade validation manually for retrieved elements
                handleCascadeChange('metal', fetchedData.metal, fetchedData);
            } else {
                alert(data.message || "Database me yeh Tag ID nahi mili!");
                setIsEditing(false);
                setIsDBRecord(false);
            }
        } catch (error) {
            alert("Backend server connected nahi hai!");
        }
    };
   

    const handleAddOrUpdateItem = async () => {
    if (!formData.tagText || !formData.itemName || !formData.weight) {
        alert("Tag ID, Item Name aur Weight zaroor bharein!");
        return;
    }

    if (isDBRecord) {
        try {
            const response = await fetch(`${baseURL}/api/update_single_stock/`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData)
            });
            const result = await response.json();
            
            if (result.success) {
                alert(result.message);
                setFormData({
                    purchaseBillNo: formData.purchaseBillNo,
                    metal: masterMetals[0] || '',
                    purity: '',
                    tagText: '',
                    itemGroup: '',
                    itemName: '',
                    weight: '',
                    making: '',
                    remarks: ''
                });
                setIsEditing(false);
                setIsDBRecord(false);
                fetchNextTagId();
                loadInitialMetals();
            } else {
                alert("Error: " + result.message);
            }
        } catch (error) {
            alert("Database update crash ho gaya!");
        }
        return;
    }

    // --- 🚀 LOCAL GRID ADDITION LOGIC WITH AUTO-INCREMENT ---
    let currentTagInt = parseInt(formData.tagText, 10);
    let nextFormattedTag = "";

    if (isEditing && !isDBRecord) {
        setItemsList(prev => prev.map(item => item.tagText === formData.tagText ? formData : item));
        setIsEditing(false);
        alert("Local grid table me update ho gaya!");
        
        // Agar local edit hua hai, toh hum database ka sahi fresh next tag fetch kar lenge
        fetchNextTagId(); 
    } else {
        const duplicate = itemsList.some(item => item.tagText === formData.tagText);
        if (duplicate) {
            alert("Yeh Tag ID pehle se list me hai!");
            return;
        }
        
        // 1. Grid me current item add karo
        setItemsList(prev => [...prev, formData]);

        // 2. 🔥 AUTO INCREMENT LOGIC: Agla Tag ID locally calculate karo (+1)
        if (!isNaN(currentTagInt)) {
            let nextTagInt = currentTagInt + 1;
            // padding maintain rakhega jaise '00006' ka '00007' banayega
            nextFormattedTag = String(nextTagInt).padStart(formData.tagText.length, '0');
        } else {
            nextFormattedTag = ""; // Safety fallback agar tag numeric na ho
        }
    }

    // 3. Form state ko clean karein aur naya incremental Tag set karein
    setFormData(prev => ({
        ...prev,
        tagText: nextFormattedTag, // Yahan automatic agla tag set ho gaya! 🎯
        weight: '',
        making: '',
        remarks: ''
    }));

    // Agar local edit chal rha tha toh ye line form handle kar legi, incremental ke liye humne locally handle kar liya hai
    if (isEditing) {
        fetchNextTagId();
    }
};

    // const handleRemoveItem = (tagToRemove) => {
    //     setItemsList(prev => prev.filter(item => item.tagText !== tagToRemove));
    // };
    const handleRemoveItem = (tagToRemove) => {
        setItemsList(prevList => {
            // 1. Tag remove karein
            const updatedList = prevList.filter(item => item.tagText !== tagToRemove);

            // Agar remove hone ke baad list bilkul khali ho jaye
            if (updatedList.length === 0) {
                fetchNextTagId(); // Direct DB se naya tag fetch karein
                return [];
            }

            // 2. Pehle item ki Tag ID se start number aur length calculate karein
            const firstTagStr = prevList[0].tagText; // e.g. "00001"
            const tagLength = firstTagStr.length;
            let startInt = parseInt(firstTagStr, 10);

            if (isNaN(startInt)) {
                // Safety Fallback: Agar numeric na ho
                return updatedList;
            }

            // 3. Grid ke bache hue saare items ko dubara sequence me (00001, 00002...) re-index karein
            const reindexedList = updatedList.map((item, idx) => {
                const currentTagInt = startInt + idx;
                const newTagStr = String(currentTagInt).padStart(tagLength, '0');
                return {
                    ...item,
                    tagText: newTagStr
                };
            });

            // 4. Input Form ke `tagText` me next fresh sequential number set karein
            const nextTagInt = startInt + reindexedList.length;
            const nextTagStr = String(nextTagInt).padStart(tagLength, '0');
            
            setFormData(prevForm => ({
                ...prevForm,
                tagText: nextTagStr
            }));

            return reindexedList;
        });
    };

    const handlePrintTags = () => {
        if (!printFrom || !printTo) {
            alert("Kripya From aur To tags dono bharein!");
            return;
        }
        window.open(`/print-preview?from=${printFrom}&to=${printTo}`, '_blank');
    };

    const handleSaveToDatabase = async () => {
        if (itemsList.length === 0) {
            alert("Pehle table me item Add kijiye!");
            return;
        }

        try {
            const response = await fetch(`${baseURL}/api/save_bulk_stock/`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: itemsList })
            });

            const data = await response.json();
            if (data.success) {
                alert("Saara Stock database me save ho gaya!");
                setItemsList([]);
                fetchNextTagId();
                loadInitialMetals();
            } else {
                alert("Bulk save failed: " + data.message);
            }
        } catch (error) {
            alert("Server connection failed!");
        }
    };

    return (
        <div className="stockin-container">
            <div className="stockin-header">Stock Entry</div>

            <fieldset className="stockin-fieldset">
                <legend>Item Details</legend>
                <div className="form-grid">
                    
                    <div className="form-group">
                        <label style={{ color: '#ff7300', fontWeight: 'bold' }}>TagText</label>
                        <input type="text" name="tagText" value={formData.tagText} onChange={handleInputChange} style={{ borderColor: '#ff7300' }} />
                    </div>
                    
                    <div className="form-group">
                        <label>Purchase Bill no</label>
                        <input type="text" name="purchaseBillNo" value={formData.purchaseBillNo} onChange={handleInputChange} />
                    </div>

                    <div className="form-group">
                        <label>Metal</label>
                        <select name="metal" value={formData.metal} onChange={handleInputChange}>
                            {masterMetals.map((m, i) => <option key={i} value={m}>{m}</option>)}
                        </select>
                    </div>

                    <div className="form-group">
                        <label>Purity</label>
                        <select name="purity" value={formData.purity} onChange={handleInputChange}>
                            {masterPurities.map((p, i) => <option key={i} value={p}>{p}</option>)}
                        </select>
                    </div>

                    <div className="form-group">
                        <label>Item Group</label>
                        <select name="itemGroup" value={formData.itemGroup} onChange={handleInputChange}>
                            {masterGroups.map((g, i) => <option key={i} value={g}>{g}</option>)}
                        </select>
                    </div>

                    <div className="form-group">
                        <label>Item Name</label>
                        <select name="itemName" value={formData.itemName} onChange={handleInputChange}>
                            {masterNames.map((n, i) => <option key={i} value={n}>{n}</option>)}
                        </select>
                    </div>

                    <div className="form-group">
                        <label>Weight (g)</label>
                        <input type="number" name="weight" value={formData.weight} onChange={handleInputChange} />
                    </div>

                    <div className="form-group">
                        <label>Making</label>
                        <div style={{ display: 'flex', gap: '5px' }}>
                            <input 
                                type="text" 
                                name="making" 
                                value={formData.making} 
                                onChange={handleInputChange} 
                                placeholder="Value"
                                style={{ width: '60%' }} 
                            />
                            <select 
                                name="makingType" 
                                value={formData.makingType} 
                                onChange={handleInputChange} 
                                style={{ width: '40%', padding: '8px', backgroundColor: '#2b2b2b', color: 'white', border: '1px solid #444', borderRadius: '4px' }}
                            >
                                <option value="Fixed">Fixed (₹)</option>
                                <option value="Pcnt">Percent (%)</option>
                                <option value="/G">Per Gram (/g)</option>
                            </select>
                        </div>
                    </div>

                    <div className="form-group-full">
                        <label>Remarks (if any)</label>
                        <input type="text" name="remarks" value={formData.remarks} onChange={handleInputChange} />
                    </div>

                    {/* 🔥 BUTTONS KO GRID KE ANDAR DAAL DIYA AUR SUBMIT LABEL KE SATH COHERENT KIYA */}
                    <div className="form-group btn-grid-actions-wrapper">
                        <label className="btn-spacer-label">&nbsp;</label>
                        <div className="action-buttons-flex">
                            <button 
                                type="button" 
                                className={isDBRecord ? "btn-update" : "btn-add"}
                                onClick={handleAddOrUpdateItem}
                            >
                                {isDBRecord ? "✏️ Update" : (isEditing ? "Update" : "Add")}
                            </button>
                            <button type="button" className="btn-search" onClick={handleSearch}>Search</button>
                        </div>
                    </div>
                </div>
                
            </fieldset>

            <div className="grid-container">
                <table className="stockin-table">
                    <thead>
                        <tr>
                            <th>Action</th>
                            <th>Tag ID</th>
                            <th>Metal</th>
                            <th>Purity</th>
                            <th>Item Group</th>
                            <th>Item Name</th>
                            <th>Weight</th>
                            <th>Making</th>
                        </tr>
                    </thead>
                    <tbody>
                        {itemsList.length === 0 ? (
                            <tr>
                                <td colSpan="8" style={{ textAlign: 'center', color: '#888' }}>Grid me koi item added nahi hai.</td>
                            </tr>
                        ) : (
                            itemsList.map((item, index) => (
                                <tr key={index}>
                                    <td>
                                        <button type="button" className="btn-remove" onClick={() => handleRemoveItem(item.tagText)}>Remove</button>
                                    </td>
                                    <td style={{ fontWeight: 'bold' }}>{item.tagText}</td>
                                    <td>{item.metal}</td>
                                    <td>{item.purity}</td>
                                    <td>{item.itemGroup}</td>
                                    <td>{item.itemName}</td>
                                    <td>{item.weight} g</td>
                                    <td>₹{item.making}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            <div className="final-submit-bar">
                <button type="button" className="btn-bulk-save" onClick={handleSaveToDatabase}>Save Stock </button>
            </div>

            {/* Print Tags Feature */}
            <fieldset className="stockin-fieldset" style={{ marginTop: '20px' }}>
                <legend>Print Tags</legend>
                <div className="form-grid" style={{ gridTemplateColumns: '1fr 1fr auto', alignItems: 'end' }}>
                    <div className="form-group">
                        <label>From Tag</label>
                        <input 
                            type="text" 
                            value={printFrom} 
                            onChange={(e) => setPrintFrom(e.target.value)} 
                            placeholder="e.g. 01011"
                        />
                    </div>
                    <div className="form-group">
                        <label>To Tag</label>
                        <input 
                            type="text" 
                            value={printTo} 
                            onChange={(e) => setPrintTo(e.target.value)} 
                            placeholder="e.g. 01050"
                        />
                    </div>
                    <div className="form-group">
                        <button 
                            type="button" 
                            className="btn-update" 
                            onClick={handlePrintTags}
                            style={{ padding: '10px 20px', height: '100%' }}
                        >
                            Print Tags
                        </button>
                    </div>
                </div>
            </fieldset>
        </div>
    );
};

export default StockIn;